import React, { Component } from 'react'

import { connect } from 'react-redux';

import {GetPixabyImages} from '../../actions/imageActions'

import Grid from '@material-ui/core/Grid';
import { CircularProgress, IconButton, InputAdornment, Paper, TextField } from '@material-ui/core';
import { SearchRounded } from '@material-ui/icons';

import logo from '../../assets/images/logo_square.png'




class ImagesModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected:'',
            search:props.currentSearch? props.currentSearch : '',
            page:1
        };

        this.observer = React.createRef();
        this.lastImageRef = node => {
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ page: prevState.page + 1 }));
                    this.handleSearch();
                }
            });
            if (node) this.observer.current.observe(node)
        }
    };
  
    handleSelect=(e,image)=>{
        this.setState({selected:image})
    }

    handleSearch=()=>{
        if(this.state.search && this.state.search!=='' && this.state.search.length<=100){

            this.props.changeSearch(this.state.search);

            const page = this.state.search===this.props.lastSearch? this.state.page : 1

            if(page===1){

                const container = document.getElementById("images_modal_container");
                container.scrollTo({top:0});

                this.setState({page:1},()=>this.props.GetPixabyImages(this.state.search, this.state.page))

            }else{
                this.props.GetPixabyImages(this.state.search, this.state.page)

            }

        }
    }
  
    SearchImage=(search)=>{
       this.setState({search:search})
    };
  
    ClearSearch=()=>{
        
    }

    handleDone=()=>{
        if(this.state.selected && this.state.selected!==''){
            this.props.onDone(this.state.selected)
        }
    }

    handleCancel =()=>{
       this.props.onCancel();
    }
  

    render() {
        return (
            <>
                <Paper elevation={3} square='false' color='secondary'>
                    <Grid id='images_modal' className="paperModalImages">
                        <Grid item container xs={12} justifyContent='space-between' alignItems='center'>
                            <Grid item className="ModalTitle">Search Images</Grid>

                            <Grid item>
                                <a href='https://pixabay.com/' target='_blank' rel='noopener noreferrer'>
                                    <img
                                        src={logo}
                                        alt='pixabay logo'
                                        className='pixabay_logo'
                                    />
                                </a>
                           

                            </Grid>
                          
                        </Grid>
                      

                        <Grid item container xs={12} justify='center'>

                            <Grid item container xs={11} alignItems='flex-start' justify='space-between'>
                                {/* Search component */}
                                <Grid item container xs={12} alignItems='center' justify='space-between' style={{heigth:'10%', margin:'0rem 0rem 1rem 0rem'}}>
                                <Grid item xs={12} sm={8} md={8} lg={8} className="MuiInput-input">
                                    <TextField
                                        id='images_modal_search'
                                        name='Search'
                                        placeholder='Search'
                                        autoFocus={true}
                                        value={this.state.search}
                                        fullWidth
                                        style={{backgroundColor: '#454446', padding:'10px 15px' ,borderRadius: '30px', color:'white' }}
                                        InputProps={{
                                            className:'textField MuiInput-input',
                                            disableUnderline:true,
                                            endAdornment:(
                                            <InputAdornment position="end">
                                                    <IconButton id='images_modal_search_btn' onClick={this.state.search!==this.props.lastSearch && this.handleSearch}>
                                                        <SearchRounded style={{color:'#959494', fontSize:40}} />
                                                    </IconButton>
                                                </InputAdornment>  
                                            )
                                        }}
                                        onChange={(e)=>this.SearchImage(e.target.value)}
                                        onKeyDown={(e)=>{
                                            if(e && e.keyCode && e.keyCode === 13 && this.state.search!==this.props.lastSearch){
                                                this.handleSearch();
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={4} style={{color:'#F0EFEF', fontSize:'24px', fontFamily:'Gotham-Book',paddingLeft:'1rem', opacity:'0.56'}}>
                                    {`${this.props.total} Results for your search`}
                                </Grid>

                                </Grid>
                            
                                {/* Images list */}
                                <Grid item container xs={12} justify='flex-start' id='images_modal_container' className="images_container">
                                    {
                                        this.props.loading &&
                                        <Grid style={{position:'absolute', top:'50%', left:'50%', transform:'translate (-50%,-50%)'}}>
                                            <CircularProgress style={{color:'#009EDD'}}/> 
                                        </Grid>
                                    }
                                    {
                                        this.props.images && this.props.images.map((i, index)=>{
                                            return(
                                                <Grid item xs={12} sm={6} md={6} lg={4} key={`image_${i.id}`} id={`image_${i.id}`}
                                                    ref={this.props.images.length === index + 1? this.lastImageRef : undefined}
                                                    style={{cursor:'pointer', borderRadius:'16px', backgroundColor:(this.state.selected===i.url)?'#009EDD':'transparent'}}
                                                    onClick={(e)=>this.handleSelect(e, i.url)}
                                                >
                                                    <img
                                                        src={i.url}
                                                        alt={i.id}
                                                        className='image_style'
                                                    />
                                                    
                                                </Grid>
                                               
                                            )
                                        })
                                    }
                                </Grid>

                                {/* Buttons section */}
                                <Grid item container justify='center' xs={12} direction='row' style={{marginTop:'1rem'}}>
                                    <Grid item container className="RepairsModalButtonCancel alingCenter" onClick={this.handleCancel}>
                                        <Grid id='cancel_btn' item container className="alingCenter">
                                            Cancel
                                        </Grid>
                                    </Grid>
                                    <Grid item container className={"RepairsModalButtonSchedule alingCenter"} onClick={this.handleDone}
                                        style={{backgroundColor:(this.state.selected!=='')? '#009EDD':'white', color: (this.state.selected==='') && '#bdbdbd'}}
                                    >
                                        <Grid id='done_btn' item container className="alingCenter" >
                                            Done
                                        </Grid>
                                    </Grid>
                                </Grid>
                        </Grid>
                                
                

                        </Grid>
                     
                    
                    </Grid>
               
                </Paper>
            </>
        )
    }
}

function mapStateToProps(state) {

    const loading = (state.imagesReducer && state.imagesReducer.loading) ? state.imagesReducer.loading : false;
    const images = (state.imagesReducer && state.imagesReducer.images) ? state.imagesReducer.images : [];
    const total = (state.imagesReducer && state.imagesReducer.total) ? state.imagesReducer.total : 0;
    const lastSearch = (state.imagesReducer && state.imagesReducer.search) ? state.imagesReducer.search : 0;

    return {
        images,
        total,
        loading,
        lastSearch
    }
};

export default connect(mapStateToProps, {GetPixabyImages})(ImagesModal);
